import { Center, Spinner } from "@chakra-ui/react";

export const ProcessLoader = () => {
  return (
    <Center w={"100vw"} h={"100vh"}>
      <Spinner size={"lg"} borderWidth={3} />
    </Center>
  );
};
